export default function (app) {
	app.directive('formatLetters', function () {
		return {
			restrict: 'A',
			link: function (scope, elem) {
				for (let i = 0; i < elem.length; i++) {
					const text = elem[i].textContent;
					if (text.indexOf('#B') != text.indexOf('B#') && text.indexOf('#B') != -1 && text.indexOf('B#') != -1) {
						const start = text.indexOf('#B');
						const end = text.indexOf('B#');
						elem[i].innerHTML = text.substring(0,start) + '<span style="font-weight:700">' + text.substring(start+2, end) + '</span>' + text.substring(end+2, text.length);
					} else if (text.indexOf('#I') != text.indexOf('I#') && text.indexOf('#I') != -1 && text.indexOf('I#') != -1) {
						const start = text.indexOf('#I');
						const end = text.indexOf('I#');
						elem[i].innerHTML = text.substring(0,start) + '<span style="font-style:italic">' + text.substring(start+2, end) + '</span>' + text.substring(end+2, text.length);
					}
				}
			}
		};
	});
};
